const accordion = {
	elements: {
		$accordionButton: $('.js-accordion-button'),
	},

	selectors: {
		accordion:          '.js-accordion',
		accordionContainer: '.js-accordion-container',
		accordionParent: '.js-accordion-parent',
	},

	init() {
		this.initEvents()
	},

	initEvents() {
		this.elements.$accordionButton.on('click', this.handleAccordion.bind(this))
	},

	handleAccordion(e) {
		const $accordion          = $(e.currentTarget).closest(this.selectors.accordion)
		const $accordionContainer = $accordion.find(this.selectors.accordionContainer)
		const $parent = $accordion.closest(this.selectors.accordionParent)
		const $allAccordionContainer = $parent.find(this.selectors.accordionContainer)
		const isInert = $accordionContainer.prop('inert')

		$allAccordionContainer.prop('inert', true)
		$accordionContainer.prop('inert', !isInert)
	},
}

accordion.init()